"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableWaiverTestKeyStringsSchema = void 0;
const zod_1 = require("zod");
// Zod schema for ReceivableWaiverTestKeyStrings
exports.ReceivableWaiverTestKeyStringsSchema = zod_1.z.object({
    externalReceivableId: zod_1.z.string(),
    borrowingBaseTestKeys: zod_1.z.string(),
});
//# sourceMappingURL=BorrowingBase.js.map